module.exports = "/feedback_success-a0ece7d4ce34a6e01f44e9223ac9bc35.svg";